import RadioButtonItem, { RadioButtonItemProps } from './RadioButtonItem';

export type { RadioButtonItemProps };
export default RadioButtonItem;
